/**
 * @param {string|null|undefined} value
 * @returns {string}
 */
export function formatSignableUntil(value) {
    if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}(?:$|T| )/.test(value)) {
        return "–";
    }

    const date = value.substring(0, 10);
    const parsed = new Date(`${date}T00:00:00Z`);

    if (date.startsWith("0000-") || Number.isNaN(parsed.getTime()) || parsed.toISOString().substring(0, 10) !== date) {
        return "–";
    }

    return date;
}
